import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const WordPressCTA = () => {
  const scrollToRequest = () => {
    document.getElementById('custom-request')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-black relative overflow-hidden">
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-black to-luxury-900/30" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white">
            Ready to Build Your Next{' '}
            <span className="bg-gradient-to-r from-gold via-primary to-gold bg-clip-text text-transparent">
              AI-Powered Plugin
            </span>
            ?
          </h2>
          <p className="text-lg text-white/70 mb-10 max-w-2xl mx-auto">
            Let's transform your WordPress site with intelligent automation and custom AI solutions.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              size="lg"
              onClick={scrollToRequest}
              className="group"
            >
              Request a Custom Plugin
              <Sparkles className="w-4 h-4 ml-2 group-hover:rotate-12 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              asChild
            >
              <a href="/services/portfolio">
                View Our Work
                <ArrowRight className="w-4 h-4 ml-2" />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WordPressCTA;
